
<!--  -->
<template>
  <div class='announce--wrap'>
    <div class="announce__title">公告中心</div>
    <div class="announce__search--wrap">
      <GButton text="全部内容"
               width="112px"
               height="38px"
               @click="resetSearch"></GButton>
      <div class="input--wrap">
        <input type="text"
               v-model="searchText"
               placeholder="请输入搜索内容">

        <div @click="toSearch"
             class="iconfont icon-sousuo"
             style="font-size: 18px;color:rgba(153, 153, 153, 1);margin-left: 10px;cursor: pointer;"></div>

      </div>
    </div>
    <div class="announce__content--wrap">
      <div class="announce__item--wrap"
           v-for="item in items"
           :key=item.id
           @click="toDetail(item.id)">
        <span class="announce__item__type"
              v-if="item.type">{{ item.type }}</span>
        <span class="announce__item__title"> {{ item.title }}</span>
        <span class="announce__item__time">{{ item.time }}</span>
      </div>
    </div>
    <div class="line"></div>
    <div class="pagination--wrap">
      <PaginateView :page-count="20"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    container-class="pagination"
                    page-class="announce-page-item"
                    active-class="announce-active-class"
                    page-link-class="announce-page-link-class">
        <template #prevContent>
          <div class='iconfont icon-jiantou-you jtz'
               style=''></div>
        </template>
        <template #nextContent>
          <div class='iconfont icon-jiantou-you jty'
               style=''></div>
        </template>
      </PaginateView>

      <input type="phone"
             v-model.number="pageText"
             oninput=" value=value.replace(/[^0-9.]/g,'')"
             placeholder=""
             style="outline: none;margin-left: 20px;margin-top:20px;height: 30px;width: 30px;border: 1px solid rgba(204, 204, 204, 1);border-radius: 2px ;background-color: transparent;text-align: center;">

      <div @click="toPage"
           style="font-size: 16px;color:rgba(51, 51, 51, 1);margin-left: 10px;cursor: pointer;margin-top: 20px;">前往</div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'AnnouncementView',
  components: {},
  data () {
    return {
      pageText: '',
      searchText: '',
      pagination: {
        currentPage: 1,
        perPage: 10,
        total: 100
      },
      items: [
        {
          id: 1,

          time: '2023-07-27',
          title: '码码落科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道',
          url: 'http://www.baidu.com',
          type: 'new'
        }, {
          id: 2,
          type: '重要',
          time: '2023-07-27',
          title: '码码落科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道',
          url: 'http://www.baidu.com'
        }, {
          id: 3,
          type: '重要',
          time: '2023-07-27',
          title: '码码落科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道',
          url: 'http://www.baidu.com'
        }, {
          id: 4,
          type: '重要',
          time: '2023-07-27',
          title: '码码落科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道',
          url: 'http://www.baidu.com'
        }, {
          id: 5,
          type: '重要',
          time: '2023-07-27',
          title: '码码落科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道',
          url: 'http://www.baidu.com'
        }, {
          id: 6,
          type: '重要',
          time: '2023-07-27',
          title: '码码落科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道',
          url: 'http://www.baidu.com'
        }, {
          id: 7,
          type: '重要',
          time: '2023-07-27',
          title: '码码落科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道',
          url: 'http://www.baidu.com'
        }, {
          id: 8,
          type: '重要',
          time: '2023-07-27',
          title: '码码落科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道',
          url: 'http://www.baidu.com'
        }, {
          id: 9,
          type: '',
          time: '2023-07-27',
          title: '码码落科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道',
          url: 'http://www.baidu.com'
        }, {
          id: 10,
          type: '',
          time: '2023-07-27',
          title: '码码落科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道',
          url: 'http://www.baidu.com'
        }
      ]
    }
  },
  computed: {},
  watch: {},
  // 方法集合
  methods: {
    toPage () {

    },
    toDetail (id) {
      this.$router.push({ name: 'announceDetail', params: { announceId: Number(id) } })
    },

    clickCallback (pageNum) {
      console.log(pageNum)
    },
    resetSearch () {
      this.searchText = ''
    },
    toSearch () {

    }
  },
  created () {

  },
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' >
//@import url(); 引入公共css类
.announce--wrap {
  padding: 0 360px;
  background-color: rgba(245, 247, 251, 1);
  padding-top: 100px;
  padding-bottom: 20px;
  .announce__title {
    font-size: 32px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 46.34px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    // margin-top: 100px;
  }
  .announce__search--wrap {
    display: flex;
    justify-content: space-between;
    .input--wrap {
      background-color: white;
      padding: 7px 16px;
      border-radius: 4px;
      display: flex;
      align-items: center;
    }
    input {
      border: none !important;
      outline: none;
    }
  }
}

.announce__content--wrap {
  margin-top: 40px;
  margin-bottom: 50px;
  height: 640px;
  overflow: auto;
  background-color: white;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .announce__item--wrap {
    cursor: pointer;
    width: 100%;
    height: 64px;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 0 24px;

    .announce__item__type {
      padding: 2px 8px;
      background-color: rgba(255, 0, 13, 0.1);
      color: rgba(255, 0, 13, 1);
      border-radius: 2px;
      font-size: 14px;
    }
    .announce__item__title {
      font-size: 18px;
      flex-grow: 1;
      text-overflow: ellipsis;
      color: rgba(51, 51, 51, 1);
      &:not(:first-child) {
        margin-left: 8px;
      }
    }
    .announce__item__time {
      font-size: 18px;
      color: rgba(153, 153, 153, 1);
    }
  }
}
.line {
  height: 1px;
  width: 100%;
  background: rgba(0, 0, 0, 0.06);
}
.pagination--wrap {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination {
  display: flex;
  list-style-type: none;
  align-items: center;
  margin-bottom: 0px;
  margin-top: 20px;
  // cursor: pointer;
}
.announce-page-item {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin: 0 10px;

  &:hover {
    background-color: rgba(153, 153, 153, 0.1);
    border-radius: 4px;
  }
}
.announce-page-link-class {
  color: #333;
}
.announce-active-class {
  background-color: rgba(153, 153, 153, 0.1);
  border-radius: 4px;
  .announce-page-link-class {
    color: $color-primary;
  }
}
.jtz {
  font-size: 20px;
  transform: rotate(180deg);
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px;
  &:hover {
    background-color: rgba(153, 153, 153, 0.1);
  }
}
.jty {
  font-size: 20px;

  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px;
  &:hover {
    background-color: rgba(153, 153, 153, 0.1);
  }
}
</style>
